import request from '../helpers/request';

const referrals = {};

referrals.FORM_FIELDS = {
    id: null,
    username: '',
    password: '',
    name: '',
    enabled: false,
    merchants: []
};

referrals.fieldValidator = {};

referrals.fieldValidator.username = (fields, errors) => {
    if (!fields.username) {
        errors.username = 'Please insert username';
        return;
    }
    if (fields.username.length < 3 || fields.username.length > 255) {
        errors.username = 'Username should be between 3 and 255 characters long';
    }
    fields.username = fields.username.trim();
};

referrals.fieldValidator.password = (fields, errors) => {
    if (!fields.id && !fields.password) {
        errors.password = 'Please insert password';
        return;
    }
    if (fields.password && fields.password.length < 6) {
        errors.password = 'Password should be at least 6 characters long';
    }
};

referrals.fieldValidator.name = (fields, errors) => {
    if (!fields.name) {
        errors.name = 'Please insert name';
        return;
    }
    if (fields.name.length < 1 || fields.name.length > 255) {
        errors.name = 'Name should be between 1 and 255 characters long';
    }
    fields.name = fields.name.trim();
};

referrals.fieldValidator.merchants = (fields, errors) => {
    if (!Array.isArray(fields.merchants)) {
        errors.merchants = 'Merchants should be an array';
        return;
    }
    fields.merchants.forEach((merchant, index) => {
        if (!merchant.merchant_id) {
            errors[`merchants_${index}_merchant_id`] = 'Merchant is required';
        }
        if (merchant.percentage === undefined || merchant.percentage === null || merchant.percentage === '') {
            errors[`merchants_${index}_percentage`] = 'Percentage is required';
        } else {
            const percentage = parseFloat(merchant.percentage);
            if (isNaN(percentage) || percentage < 0 || percentage > 100) {
                errors[`merchants_${index}_percentage`] = 'Percentage should be between 0 and 100';
            }
        }
    });
};

referrals.methodValidator = {};

referrals.methodValidator.add = (fields, errors = {}) => {
    referrals.fieldValidator.username(fields, errors);
    referrals.fieldValidator.password(fields, errors);
    referrals.fieldValidator.name(fields, errors);
    referrals.fieldValidator.merchants(fields, errors);
    return errors;
};

referrals.methodValidator.edit = (fields, errors = {}) => {
    if (!fields.id) {
        errors.id = 'ID is required';
    }
    if (fields.username !== undefined) {
        referrals.fieldValidator.username(fields, errors);
    }
    if (fields.password && fields.password !== '') {
        referrals.fieldValidator.password(fields, errors);
    }
    if (fields.name !== undefined) {
        referrals.fieldValidator.name(fields, errors);
    }
    if (fields.merchants !== undefined) {
        referrals.fieldValidator.merchants(fields, errors);
    }
    return errors;
};

referrals.index = (filters = {}) => {
    return request.get('/referrals', filters, true);
};

referrals.get = (id) => {
    return request.get('/referrals/get', {id}, true);
};

referrals.add = (data) => {
    return request.post('/referrals/add', data, true);
};

referrals.edit = (data) => {
    return request.put('/referrals/edit', data, true);
};

referrals.delete = (id) => {
    return request.delete('/referrals/delete', {id}, true);
};

referrals.getStats = (filters = {}) => {
    return request.get('/referrals/stats', filters, true);
};

referrals.init = async () => {
    return request.get('/init');
};

referrals.login = async (username, password) => {
    return request.post('/referrals/login', {username, password}, true);
};

referrals.logout = async () => {
    await request.post('/referrals/logout', {}, true);
};

export default referrals;

